module.exports = __webpack_public_path__ + "img/webinars_7_1920.9004370.jpg";